import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import AprilPicto from '@/components/shared/april-picto';
import { PictoFacilitePaiement } from '@/assets/icons-april-fr/pictos';
import SelectContract from "@/components/shared/select-contract";
import CotisationSelectedContract from "@/pages/paiements/cotisations/cotisation-selected-contract";
import { useReceiptsUnpaid } from '@/hooks/api/use-receipts';
import { formatDate } from '@/lib/dates';
import type { Quittance } from '@/types/api/payment';

const Cotisations = () => {
    const data = (useReceiptsUnpaid().data?.data ?? []) as Quittance[];

    return (
        <div className="space-y-6 mt-6">
            {/* Cotisations à régler */}
            {data.length >= 1 && (
                <Card>
                    <CardHeader className="pb-6 border-b">
                        <CardTitle className="text-lg flex items-center gap-2">
                            <AlertTriangle className="w-5 h-5 text-warning" />
                            Cotisations à régler
                            <Badge variant="warning" className="ml-1">{data.length}</Badge>
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6">
                        <div className="space-y-4">
                            {data.map((r, i) => (
                                <div key={i} className="p-6 rounded-lg border bg-muted/30 transition-all duration-200 hover:bg-muted/50">
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                                        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
                                            <div>
                                                <p className="text-muted-foreground">Période</p>
                                                <p className="font-medium">Du {formatDate(r.dateDebut)} au {formatDate(r.dateFin)}</p>
                                            </div>
                                            <div>
                                                <p className="text-muted-foreground">Montant</p>
                                                <p className="font-semibold text-destructive">{r.montant}{'\u00A0'}€</p>
                                            </div>
                                            <div>
                                                <p className="text-muted-foreground">Motif</p>
                                                <p className="font-medium">{r.type}</p>
                                            </div>
                                            <div>
                                                <p className="text-muted-foreground">Contrat</p>
                                                <p className="font-medium">{r.numeroPolice}</p>
                                            </div>
                                        </div>
                                        <div className="shrink-0">
                                            {r.pay_link ? (
                                                <Button asChild size="sm" variant="outline" className="cursor-pointer">
                                                    <a target="_blank" rel="noopener noreferrer" href={`${r.pay_link}?url_return=${window.location.href}`}>
                                                        <AprilPicto icon={PictoFacilitePaiement} size="sm" />
                                                        Payer ma cotisation
                                                    </a>
                                                </Button>
                                            ) : (
                                                <Badge variant="secondary">
                                                    {(r.pay_link_reason?.[0] ?? '').replace('_', ' ')}
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>
            )}

            {/* Quittances par contrat */}
            <div data-tutorial="paiements-quittances">
                <SelectContract>
                    <CotisationSelectedContract />
                </SelectContract>
            </div>
        </div>
    );
};

export default Cotisations;
